import { render, staticRenderFns } from "./TabHandler.vue?vue&type=template&id=0078a9da&scoped=true&"
import script from "./TabHandler.vue?vue&type=script&lang=js&"
export * from "./TabHandler.vue?vue&type=script&lang=js&"
import style0 from "./TabHandler.vue?vue&type=style&index=0&id=0078a9da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0078a9da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0078a9da')) {
      api.createRecord('0078a9da', component.options)
    } else {
      api.reload('0078a9da', component.options)
    }
    module.hot.accept("./TabHandler.vue?vue&type=template&id=0078a9da&scoped=true&", function () {
      api.rerender('0078a9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/運勢書2024/TabHandler.vue"
export default component.exports